import React from 'react'

export default function Logo() {
  return (
    <div className='flex flex-col space-y-2 md:space-y-4 py-2 md:py-8 text-[#FFFAF0]'>
    
      <h1 className='text-3xl md:text-6xl mx-auto text-center font-logo'>Kelly Hunter</h1>
      <span className='josefin-font text-center mx-auto w-full! text-xs md:text-sm'>Theatre Director & Educator</span>
    </div>
  )
}
